import { siteStore } from "../store";

export const setDashboardTopUpRedirectUrl = (redirectUrl?: string) =>
  (siteStore.dashboardTopUpRedirectUrl = redirectUrl);
